import axios from 'axios'

export class ProductListService {
  constructor() {
    const dataset = document.getElementById('js-data').dataset
    this.baseUrl = dataset.baseUrlFrontNamed
    this.customerId = dataset.customerId
    this.hashedCustomerId = dataset.hashedCustomerId
  }

  async getWishLists() {
    try {
      const { data } = await axios.get(`${this.baseUrl}/customers/wishlists`, {
        params: { cid: this.customerId, h: this.hashedCustomerId },
      })
      let wishlists = data.wishlists
      if (!wishlists.length) {
        // ほしい物リストが未作成の場合、新規に作成する
        const { data } = await axios.post(
          `${this.baseUrl}/customers/wishlists/upsert`,
          {
            customerId: this.customerId,
            h: this.hashedCustomerId,
          }
        )
        wishlists = data.wishlist
      }
      return { hasError: false, wishlists }
    } catch (error) {
      console.error(error)
      return { hasError: true, wishlists: [] }
    }
  }

  async removeProduct({ productListId, productId }) {
    try {
      await axios.delete(
        `${this.baseUrl}/customers/wishlists/${productListId}/remove_product`,
        {
          data: {
            customerId: this.customerId,
            h: this.hashedCustomerId,
            productId,
          },
        }
      )
    } catch (error) {
      console.error(error)
    }
  }

  async addProduct({ productId }) {
    try {
      await axios.post(`${this.baseUrl}/customers/wishlists/add_product`, {
        customerId: this.customerId,
        h: this.hashedCustomerId,
        productId,
      })
    } catch (error) {
      console.error(error)
    }
  }

  static isLogin() {
    const dataset = document.getElementById('js-data')?.dataset
    return !!dataset.customerId
  }
}
